import {emotionStyled} from '@packages/utilities/styled';

export const ViewView = emotionStyled('div')(
  {},
  {
    componentName: 'View',
  }
);
